/* eslint-disable @typescript-eslint/no-explicit-any */

export type LoggerLevel = keyof typeof LoggerSeverityLevel;

export type LoggerApiHandler = (
  printer: LoggerPrinter,
  level: LoggerLevel,
  metadata: LoggerMetadata,
  message: any,
  optionalParams: any[],
) => void;

export type LoggerInternalApiHandler = (metadata: LoggerMetadata, message: any, optionalParams: any[]) => void;

export type LoggerPrinter = (message: any, ...optionalParams: any[]) => void;

export interface LoggerApi {
  fatal: LoggerPrinter;
  error: LoggerPrinter;
  warn: LoggerPrinter;
  info: LoggerPrinter;
  debug: LoggerPrinter;
}

export interface LoggerInternalApi {
  fatal: LoggerInternalApiHandler;
  error: LoggerInternalApiHandler;
  warn: LoggerInternalApiHandler;
  info: LoggerInternalApiHandler;
  debug: LoggerInternalApiHandler;
}

export interface LoggerMetadata {
  context?: string;
  correlationId?: string;
  ip?: string;
  route?: string;
}

/**
 * Logger severity level.
 *
 * Inspired by RFC 5424 The Syslog Protocol
 * @see https://tools.ietf.org/html/rfc5424#page-11
 */
export enum LoggerSeverityLevel {
  FATAL = 1,
  ERROR = 2,
  WARN = 3,
  INFO = 4,
  DEBUG = 5,
  SILENT = 99,
}
